export enum FinanceRequestPriceId {
  GrossPrice = 'grossPrice',
  NetPrice = 'netPrice',
  GrossListPrice = 'grossListPrice',
  BaseListPrice = 'baseListPrice'
}

export enum FinanceRequestAdditionalValuesType {
  EnvironmentalBonus = 'environmentalBonusManufacturer'
}

export interface FcisRateInfo {
  rate: string | null;
  rateAsNumber: number;
  label: string;
}

export interface FinanceRate {
  baumuster: string;
  rate: string;
}

// Looks like this:
//   AU-204: { value: "4,31 €", rawValue: 4.31 }
//   AU-211: { value: "40,05 €", rawValue: 40.05 }
//   AU-215: { value: "4,31 €", rawValue: 4.31 }
//   ...
export type FinancialRates = Record<string, { value: string; rawValue: number }>;

export interface FinanceLabelAndRate {
  label: string;
  rate: string;
}

export interface FcisCustomerTypeActivation {
  b2c: boolean;
  b2b: boolean;
  b2e: boolean;
}

export interface FinanceConfig {
  useFcis: FcisCustomerTypeActivation | boolean;
  showPrice: boolean;
  showNetPrice: boolean;
  showRates: boolean;
  preventRatesForMotorization: boolean;
}
